<template>
  <v-card
    color="grey lighten-4"
    height="100%"
  >
    <v-card-title>
      <v-container
        fluid
        grid-list-lg
      >
        <!-- function trigger card START -->
        <template v-if="trigger.function !== undefined">
          <v-row>
            <v-col
              cols="9"
              class="headline"
            >
              <v-icon
                large
              >
                {{ $appConfig.trigger.icon }}
              </v-icon>
              {{ trigger.function.name }}
            </v-col>
            <v-col
              v-if="!isNew"
              class="text-right"
              cols="3"
            >
              <v-menu>
                <template v-slot:activator="{ on }">
                  <v-btn
                    style="margin-top: -10px;"
                    color="grey lighten-1"
                    dark
                    text
                    fab
                    v-on="on"
                  >
                    <v-icon>mdi-settings</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item @click="resyncDialog=!resyncDialog">
                    <v-list-item-title><v-icon>mdi-autorenew</v-icon> Resync</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="deleteDialog=!deleteDialog">
                    <v-list-item-title><v-icon>mdi-delete</v-icon> Delete</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              <v-dialog
                v-model="deleteDialog"
                persistent
                max-width="400px"
              >
                <v-card>
                  <v-card-title class="headline">
                    Delete this trigger
                  </v-card-title>
                  <v-card-text>Are you sure you want to delete this trigger?</v-card-text>
                  <v-card-actions>
                    <v-spacer />
                    <v-btn
                      color=""
                      text
                      @click.native="deleteDialog = false"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      color="primary"
                      text
                      @click.native="deleteTrigger(trigger)"
                    >
                      Delete
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-dialog
                v-model="resyncDialog"
                persistent
                max-width="400px"
              >
                <v-card>
                  <v-card-title class="headline">
                    Resync this trigger
                  </v-card-title>
                  <v-card-text>Are you sure you want to resync this trigger?</v-card-text>
                  <v-card-actions>
                    <v-spacer />
                    <v-btn
                      color=""
                      text
                      @click.native="resyncDialog = false"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      color="primary"
                      text
                      @click.native="resyncTrigger(trigger)"
                    >
                      Resync
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-col>
            <v-col
              cols="12"
              class="grey--text caption"
            >
              {{ trigger.function.description }}
            </v-col>
            <template v-for="(label, index) in trigger.function.labels">
              <v-chip :key="index">
                <v-avatar class="primary">
                  {{ label.name.slice(0, 1).toUpperCase() }}
                </v-avatar> {{ label.name }}
              </v-chip>
            </template>
            <v-col cols="12">
              <v-divider />
            </v-col>
            <v-col cols="12">
              <v-icon
                v-if="trigger.type==='date_time'"
                :color="$appConfig[trigger.type].color"
              >
                {{ $appConfig[trigger.type].icon }}
              </v-icon>
              <template v-if="trigger.type==='date_time'">
                <template> {{ freqSelected.text }} </template>
                <template v-if="trigger.freq_choice==='YEAR' || trigger.freq_choice==='MONTH'">
                  {{ dateSelected.text }}
                </template>
                <template v-if="trigger.freq_choice==='YEAR'">
                  of {{ monthSelected.text }}
                </template>
                <template v-if="trigger.freq_choice==='WEEK'">
                  on
                  <span
                    v-for="day in daysSelected"
                    :key="day.value"
                  >
                    {{ day+',' }}
                  </span>
                </template>
                <template v-if="trigger.freq_choice !='HOUR'">
                  at {{ hourToDisplay+":"+trigger.minute_choice }}
                </template>
                <template v-if="trigger.freq_choice==='HOUR'">
                  at {{ trigger.minute_choice }} minutes past the
                  hour
                </template>
                <template v-if="trigger.freq_choice !='HOUR'">
                  {{ AM_PM }}
                </template>
              </template>

              <template v-if="trigger.type==='dataset'">
                {{ fetchSelected.text }} {{ requestSelected.text }}
                <v-icon :color="$appConfig[trigger.type].color">
                  {{ $appConfig[trigger.type].icon }}
                </v-icon>
                {{ isNew? trigger.source.name : trigger.source }}
              </template>

              <template v-if="trigger.type==='api' ">
                {{ fetchSelected.text }} a call on
                <v-icon
                  v-if="trigger.type !=='date_time'"
                  :color="$appConfig[trigger.type].color"
                >
                  {{ $appConfig[trigger.type].icon }}
                </v-icon>
                {{ isNew? trigger.source.name : trigger.source }}
              </template>
            </v-col>
            <template v-if="!isNew">
              <v-col cols="12">
                <v-divider />
              </v-col>
              <v-col
                class="text-center"
                cols="12"
              >
                <v-switch
                  v-model="trigger.enabled"
                  :label="trigger.enabled? 'status: enabled' : 'status: disabled'"
                  color="accent"
                  @click.native="updateEnabled(trigger)"
                />
              </v-col>
            </template>
          </v-row>
        </template>
        <!-- function trigger card END -->

        <!-- cron_dataset trigger card START -->
        <template v-else>
          <v-row>
            <v-col
              cols="10"
              class="headline"
            >
              <v-icon large>
                mdi-calendar-clock
              </v-icon>
              {{ trigger.storage_choice }} trigger
            </v-col>
            <v-col
              v-if="!isNew"
              cols="2"
            >
              <v-menu offset-y>
                <template v-slot:activator="{ on }">
                  <v-btn
                    style="margin-top: -10px;"
                    color="grey lighten-1"
                    dark
                    text
                    fab
                    v-on="on"
                  >
                    <v-icon>mdi-settings</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-tile>
                    <v-list-item-title>
                      <v-dialog
                        v-model="resyncDialog"
                        persistent
                        max-width="400px"
                      >
                        <span
                          slot="activator"
                          flat
                          fab
                        >

                          <v-icon>mdi-autorenew</v-icon> Resync

                        </span>
                        <v-card>
                          <v-card-title class="headline">
                            Resync this trigger
                          </v-card-title>
                          <v-card-text>Are you sure you want to resync this trigger?</v-card-text>
                          <v-card-actions>
                            <v-spacer />
                            <v-btn
                              color=""
                              text
                              @click.native="resyncDialog = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              color="primary"
                              text
                              @click.native="resyncTrigger(trigger)"
                            >
                              Resync
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </v-list-item-title>
                  </v-list-tile>
                  <v-list-tile>
                    <v-list-item-title>
                      <v-dialog
                        v-model="deleteDialog"
                        persistent
                        max-width="400px"
                      >
                        <span
                          slot="activator"
                          flat
                          fab
                        >

                          <v-icon>delete</v-icon> Delete

                        </span>
                        <v-card>
                          <v-card-title class="headline">
                            Delete this trigger
                          </v-card-title>
                          <v-card-text>Are you sure you want to delete this trigger?</v-card-text>
                          <v-card-actions>
                            <v-spacer />
                            <v-btn
                              color=""
                              text
                              @click.native="deleteDialog = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              color="primary"
                              text
                              @click.native="deleteTrigger(trigger)"
                            >
                              Delete
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </v-list-item-title>
                  </v-list-tile>
                  <template />
                </v-list>
              </v-menu>
            </v-col>
            <v-col
              cols="12"
              class="grey--text caption"
            >
              Recreate your dataset at the specified schedule
            </v-col>
            <v-col cols="12">
              <v-divider />
            </v-col>
            <v-col cols="12">
              {{ trigger.type }}
              <v-icon>{{ $appConfig['date_time'].icon }}</v-icon>
              <template> {{ freqSelected.text }} </template>
              <template v-if="trigger.freq_choice==='WEEK'">
                on {{ trigger.day_choice }}
              </template>
              <template>at {{ hourToDisplay+":"+trigger.minute_choice + " " + AM_PM }}</template>
            </v-col>
            <template v-if="!isNew">
              <v-col cols="12">
                <v-divider />
              </v-col>
              <v-col
                class="text-center"
                cols="12"
              >
                <v-switch
                  v-model="trigger.enabled"
                  :label="trigger.enabled? 'status: enabled' : 'status: disabled'"
                  color="accent"
                  @click.native="updateEnabled(trigger)"
                />
              </v-col>
            </template>
          </v-row>
        </template>
        <!-- cron_dataset trigger card START -->
      </v-container>
    </v-card-title>
  </v-card>
</template>

<script>
  import TriggerService from '../../Dashboard/Views/Trigger/services/TriggerService'
  export default {
    props: {
      isNew: {
        type: Boolean,
        default: function () {
          return true
        },
      },
      trigger: {
        type: Object,
        default: function () {
          return {}
        },
      },
    },
    data () {
      return {
        dates: [{ text: 'on the 1st', value: '01' }, { text: 'on the 2nd', value: '02' }, { text: 'on the 3rd', value: '03' }, { text: 'on the 4th', value: '04' }, { text: 'on the 5th', value: '05' }, { text: 'on the 6th', value: '06' }, { text: 'on the 7th', value: '07' }, { text: 'on the 8th', value: '08' }, { text: 'on the 9th', value: '09' }, { text: 'on the 10th', value: '10' }, { text: 'on the 11th', value: '11' }, { text: 'on the 12th', value: '12' }, { text: 'on the 13th', value: '13' }, { text: 'on the 14th', value: '14' }, { text: 'on the 15th', value: '15' }, { text: 'on the 16th', value: '16' }, { text: 'on the 17th', value: '17' }, { text: 'on the 18th', value: '18' }, { text: 'on the 19th', value: '19' }, { text: 'on the 20th', value: '20' }, { text: 'on the 21th', value: '21' }, { text: 'on the 22th', value: '22' }, { text: 'on the 23th', value: '23' }, { text: 'on the 24th', value: '24' }, { text: 'on the 25th', value: '25' }, { text: 'on the 26th', value: '26' }, { text: 'on the 27th', value: '27' }, { text: 'on the 28th', value: '28' }, { text: '2 days before the last day', value: '-2' }, { text: '1 day before the last day', value: '-1' }, { text: 'on the last day', value: '00' }],
        months: [{ text: 'January', value: 'JAN' }, { text: 'February', value: 'FEB' }, { text: 'March', value: 'MAR' }, { text: 'April', value: 'APR' }, { text: 'May', value: 'MAY' }, { text: 'June', value: 'JUN' }, { text: 'July', value: 'JUL' }, { text: 'August', value: 'AUG' }, { text: 'September', value: 'SEP' }, { text: 'October', value: 'OCT' }, { text: 'November', value: 'NOV' }, { text: 'December', value: 'DEC' }],
        days: [{ id: 0, text: 'Monday', value: 'MON' }, { id: 1, text: 'Tuesday', value: 'TUE' }, { id: 2, text: 'Wednesday', value: 'WED' }, { id: 3, text: 'Thursday', value: 'THU' }, { id: 4, text: 'Friday', value: 'FRI' }, { id: 5, text: 'Saturday', value: 'SAT' }, { id: 6, text: 'Sunday', value: 'SUN' }],
        freqs: [{ value: 'HOUR', text: 'Hourly' }, { value: 'DAY', text: 'Daily' }, { value: 'WEEK', text: 'Weekly' }, { value: 'MONTH', text: 'Monthly' }, { value: 'YEAR', text: 'Annualy' }],
        AM_PM: '',
        deleteDialog: false,
        resyncDialog: false,
        fetches: [{
                    value: 'PRE',
                    text: 'Before',
                  },
                  {
                    value: 'POST',
                    text: 'After',
                  },
        ],
        requests: [{
                     value: 'READ',
                     text: 'a read on',
                   },
                   {
                     value: 'UPDATE',
                     text: 'an update on',
                   },
                   {
                     value: 'DELETE',
                     text: 'a delete on',
                   },
        ],
        settingsItems: [{
                          title: 'Delete',
                          function: function (trigger) {
                            console.log(trigger)
                            TriggerService.deleteTrigger(trigger)
                          },
                        },
                        {
                          title: 'Settings',
                          function: function (trigger) {
                            console.log('settings ')
                          },
                        },
        ],
      }
    },
    computed: {
      freqSelected: function () {
        return this.freqs.find(x => x.value === this.trigger.freq_choice)
      },
      monthSelected: function () {
        return this.months.find(x => x.value === this.trigger.month_choice)
      },
      dateSelected: function () {
        return this.dates.find(x => x.value === this.trigger.date_choice)
      },
      fetchSelected: function () {
        return this.fetches.find(x => x.value === this.trigger.fetch_choice)
      },
      requestSelected: function () {
        return this.requests.find(x => x.value === this.trigger.request_choice)
      },
      daysSelected: function () {
        var d = []
        if (this.trigger.day_choice != null) {
          for (var i = 0; i < this.trigger.day_choice.length; i++) {
            for (var j = 0; j < this.days.length; j++) {
              if (this.trigger.day_choice[i] == this.days[j].value) {
                d.push(this.days[j].text)
              }
            }
          }
        }
        return d
      },
      hourToDisplay: function () {
        if (Number(this.trigger.hour_choice) < 12) {
          this.AM_PM = 'AM'
          if (Number(this.trigger.hour_choice) === 0) {
            return '12'
          } else {
            return String(this.trigger.hour_choice)
          }
        } else {
          this.AM_PM = 'PM'
          if (Number(this.trigger.hour_choice) != 12) {
            return '0' + String(this.trigger.hour_choice - 12)
          } else return '12'
        }
      },
    },
    methods: {
      resyncTrigger (trigger) {
        this.resyncDialog = false
        TriggerService.resyncTrigger(trigger, this)
      },
      createTrigger () {
        this.$emit('createTrigger')
      },
      deleteTrigger (trigger) {
        this.deleteDialog = false
        TriggerService.deleteTrigger(trigger, this)
      },
      updateEnabled (trigger) {
        TriggerService.updateTrigger(trigger)
      },
      settings () {
        console.log('settings')
      },
    },
  }
</script>
